export interface LocationData {
  country: string
  administrativeAreaLevel1?: string
  administrativeAreaLevel2?: string
  locality?: string
}

export interface Destination {
  id: string
  locationName: string
  locationData: LocationData
  arrivalDatetime: Date
}

export interface DayExclusion {
  date: string // ISO date string
  breakfastProvided: boolean
  lunchProvided: boolean
  dinnerProvided: boolean
  accommodationProvided: boolean
}

export interface CostCenterAllocation {
  costCenterId: number
  percentage: number
}

export interface PerDiemWizardData {
  // Step 1: Trip Details
  startDate: Date | null
  endDate: Date | null
  destinations: Destination[]

  // Step 2: Company-paid items
  dayExclusions: DayExclusion[]

  // Budget and Project
  budgetId?: number
  projectId?: number
  subprojectId?: number

  // Cost Centers
  costCenterAllocations: CostCenterAllocation[]

  // Additional Information
  description?: string
  internalReference?: string
  files: File[]

  // Employee
  employeeId?: number
}

export const createEmptyDestination = (): Destination => ({
  id: crypto.randomUUID(),
  locationName: '',
  locationData: {
    country: '',
  },
  arrivalDatetime: new Date(),
})

export const createInitialWizardData = (): PerDiemWizardData => ({
  startDate: null,
  endDate: null,
  destinations: [createEmptyDestination()],
  dayExclusions: [],
  costCenterAllocations: [],
  files: [],
})
